import { render, staticRenderFns } from "./ProjectTalk.vue?vue&type=template&id=ec43aa6c&scoped=true"
import script from "./ProjectTalk.vue?vue&type=script&lang=js"
export * from "./ProjectTalk.vue?vue&type=script&lang=js"
import style0 from "./ProjectTalk.vue?vue&type=style&index=0&id=ec43aa6c&prod&lang=css"
import style1 from "../../css/newCreateProject.css?vue&type=style&index=1&id=ec43aa6c&prod&scoped=true&lang=css&external"
import style2 from "./ProjectTalk.vue?vue&type=style&index=2&id=ec43aa6c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec43aa6c",
  null
  
)

export default component.exports